import { Button } from '@mantine/core';
import { IconFileTypeZip } from '@tabler/icons-react';

import { Id } from '@feature/utils';

interface EvaluationDomainArchiveButtonProps {
  evaluationId: Id;
}

const onDownload = (evaluationId: Id) => {
  window.open(`/api/gov-evaluation/${evaluationId}/download-domain-archive-zip`);
};

export function GovEvaluationDomainArchiveButton({ evaluationId }: EvaluationDomainArchiveButtonProps) {
  return (
    <Button
      size="xs"
      leftSection={<IconFileTypeZip size="24px" />}
      onClick={() => onDownload(evaluationId)}
    >
      Descarcă arhiva grupată pe domeniu
    </Button>
  );
}
